/** Ignore remeasures while the tab is hidden or the calendar has collapsed to 0×0. */
export function shouldSkipCalendarLayoutRefresh(input: {
  visibilityState?: string;
  width?: number;
  height?: number;
}): boolean {
  if (input.visibilityState != null && input.visibilityState !== "visible") {
    return true;
  }
  if (input.width != null && input.width < 1) {
    return true;
  }
  if (input.height != null && input.height < 1) {
    return true;
  }
  return false;
}

function fireCalendarResize(): void {
  if (typeof document !== "undefined" && document.visibilityState !== "visible") {
    return;
  }
  window.dispatchEvent(new Event("resize"));
}

/**
 * Re-measure react-big-calendar after paint. Immediate resize on tab restore often
 * reads 0 height and month cells then show almost no events.
 */
export function scheduleCalendarLayoutRefresh(): () => void {
  if (typeof document !== "undefined" && document.visibilityState !== "visible") {
    return () => undefined;
  }

  let cancelled = false;
  const fire = () => {
    if (cancelled) return;
    fireCalendarResize();
  };

  const raf1 = requestAnimationFrame(() => {
    requestAnimationFrame(fire);
  });
  const timeoutId = window.setTimeout(fire, 50);

  return () => {
    cancelled = true;
    cancelAnimationFrame(raf1);
    window.clearTimeout(timeoutId);
  };
}
